import React, { useContext, useEffect, useState } from 'react'
import { CharacterContext } from '../../contexts/character'

import Cards from '../Cards/Cards'

import './extendedInfo.scss'

function ExtendedInfo(props) {
	let { bonuses } = useContext(CharacterContext)
	// let sizeList = { small: 'Small', medium: 'Medium', large: 'Large' }
	// Object.keys(sizeList).map((item, i) =>
	// 	console.log(item + ' ' + sizeList[item])
	// )
	// let eleList = []

	const [bonusesList, setBonusesList] = useState(bonuses)
	useEffect(() => {
		setBonusesList(bonuses)
	}, [bonuses])
	return (
		<div className='extendedInfo'>
			<Cards Name='Multipliers'>
				<div className='BonusType'>
					{/* Size */}
					{DisplaySizeMultipliers(bonusesList?.bAddSize)}
					{/* Property */}
					{DisplayElementMultipliers(bonusesList?.bAddEle)}
					{/* Race */}
					{DisplayRaceMultupliers(bonusesList?.bAddRace)}
					{/* Class*/}
					{DisplayClassMultipliers(bonusesList?.bAddClass)}
				</div>
			</Cards>
		</div>
	)
}
function bonusValue(Bonus, AllBonus) {
	return (Bonus ? Bonus : 0) + (AllBonus ? AllBonus : 0)
}
// function DisplaySizeAndClassMultipliers(bonusesList) {
// 	return (
// 		<div>
// 			{DisplaySizeMultipliers(bonusesList?.bAddSize)}
// 			{/* only display linebreak if there is size bonus */}
// 			{bonusesList?.bAddSize ? <br /> : null}
// 			{DisplayClassMultipliers(bonusesList?.bAddClass)}
// 		</div>
// 	)
// }
function DisplaySizeMultipliers(bAddSize) {
	let Sizes = ['Small', 'Medium', 'Large']
	return (
		<div className={'SizeMultiplier ' + (bAddSize ? 'visible' : 'hidden')}>
			<div className='bAddSize title'>Size Multiplier </div>
			<div
				className={
					'SizeMultiplier ' +
					(isVisible(bAddSize) ? 'visible' : 'hidden')
				}
			>
				{Sizes.map((size) =>
					DisplayMultiplier(bAddSize, 'Size_', size),
				)}
			</div>
		</div>
	)
}
function DisplayClassMultipliers(bAddClass) {
	let Classes = ['Boss', 'Normal']
	return (
		<div
			className={'ClassMultiplier ' + (bAddClass ? 'visible' : 'hidden')}
		>
			<div className='bAddClass title'>Class Multiplier </div>
			{Classes.map((class_) =>
				DisplayMultiplier(bAddClass, 'Class_', class_),
			)}
		</div>
	)
}
function DisplayRaceMultupliers(bAddRace) {
	let races = [
		'Formless',
		'Undead',
		'Brute',
		'Plant',
		'Insect',
		'Fish',
		'Demon',
		'DemiHuman',
		'Angel',
		'Dragon',
	]
	return (
		<div
			className={
				'RaceMultiplier ' + (isVisible(bAddRace) ? 'visible' : 'hidden')
			}
		>
			<div className='bAddRace title'>Race Multiplier </div>
			{races.map((race) => DisplayMultiplier(bAddRace, 'RC_', race))}
			{/* RC_Player_Human */}
			{DisplayMultiplier2(
				'Player (Human)',
				bonusValue(bAddRace?.RC_Player_Human, bAddRace?.RC_All),
			)}
			{/* RC_Player_Doram */}
			{DisplayMultiplier2(
				'Player (Doram)',
				bonusValue(bAddRace?.RC_Player_Doram, bAddRace?.RC_All),
			)}
		</div>
	)
}
function DisplayElementMultipliers(bAddEle) {
	let elements = [
		'Neutral',
		'Water',
		'Earth',
		'Fire',
		'Wind',
		'Poison',
		'Holy',
		'Dark',
		'Ghost',
		'Undead',
	]
	return (
		<div
			className={
				'ElementMultiplier ' +
				(isVisible(bAddEle) ? 'visible' : 'hidden')
			}
		>
			<div className='bAddEle title'>Element Multiplier </div>
			{elements.map((elem) => DisplayMultiplier(bAddEle, 'Ele_', elem))}
		</div>
	)
}
function DisplayMultiplier(bonus, suffix, type) {
	let value = bonusValue(bonus?.[suffix + type], bonus?.[suffix + 'All'])
	return (
		// <div className={value > 0 ? 'visible' : 'hidden'} key={type}>
		<div className={value > 0 ? 'visible' : 'hidden'} key={type}>
			{type} : {value}%
		</div>
	)
}
function DisplayMultiplier2(type, value) {
	return (
		<div className={value > 0 ? 'visible' : 'hidden'}>
			{type} :{value}%{' '}
		</div>
	)
}
function isVisible(bonus) {
	if (bonus)
		return Object.keys(bonus)
			.map((item, i) => bonus[item])
			.reduce((total, value) => (total = total + value), 0)
	return false
}

export default ExtendedInfo
